<template>
  <a-modal title="도매 등록" v-model="visible" okText="등록" cancelText="취소" @cancel="onDone">
    <a-row>
      <a-col :span="19">
        <a-auto-complete
          placeholder="도매 이름을 입력하여 주세요."
          v-model="search"
          @search="onAutoComplete"
          :dataSource="autoComplete"
          v-on:keypress.native="onSearchChange"
          style="width: 100%"
        >
          <a-input>
            <a-icon slot="suffix" type="search" @click="onAutoComplete" />
          </a-input>
        </a-auto-complete>
      </a-col>
      <a-col :span="1" />
      <a-col :span="4">
        <a-button type="primary" :icon="isPC ? 'search' : null" @click="onSearch">검색</a-button>
      </a-col>
    </a-row>

    <div v-if="wholesales.length > 0">
      <a-list itemLayout="horizontal" :dataSource="wholesales">
        <a-list-item slot="renderItem" slot-scope="wholesale">
          <a-list-item-meta
            :description="wholesale.location.building +
          ' (' + wholesale.location.mall + ') ' +
          wholesale.location.floor + '층 ' +
          wholesale.location.row + '열 ' +
          wholesale.location.place + '호'"
          >
            <a slot="title">{{wholesale.name}}</a>
          </a-list-item-meta>
          <a-button
            :icon="added.includes(wholesale.idx) ? 'check' : 'plus'"
            :type="added.includes(wholesale.idx) ? 'primary' : 'dashed'"
            @click="onSelected(wholesale)"
          >{{added.includes(wholesale.idx) ? '등록됨' : '등록' }}</a-button>
        </a-list-item>
      </a-list>
    </div>
    <div class="card-empty" v-else>
      <i class="no-content-logo"></i>
      <p>
        <b>위에서 도매 이름을 검색해주세요.</b>
      </p>
    </div>
    <template slot="footer">
      <a-button type="dashed" icon="plus" @click="editWholesale()">신규 추가</a-button>
      <a-button type="primary" @click="onDone">완료</a-button>
    </template>
  </a-modal>
</template>
<script>
import OPCODE from "../../libs/OPCODE";
import Axios from "axios";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import config from "../../config";
import _ from "lodash";
import { mapActions } from "vuex";

export default {
  name: "WholesaleAdd",
  data() {
    return {
      visible: true,
      wholesales: [],
      autoComplete: [],
      added: [],
      search: "",
      latestComplete: new Date()
    };
  },
  methods: {
    ...mapActions(["refreshWholesales", "editWholesale"]),
    async onSearch() {
      const {
        data
      } = await Axios.get(
        `${config.hostname}/v1/wholesale/add?search=` + this.search,
        { withCredentials: true }
      );
      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.wholesales = data.wholesales;
            break;
        }
      }
    },
    onSelected(wholesale) {
      const { idx } = wholesale;
      if (this.added.includes(idx)) {
        Axios.delete(`${config.hostname}/v1/wholesale/` + idx, {
          withCredentials: true
        }).then(async ({ data }) => {
          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                this.added = _.remove(this.added, k => k !== idx);
                await this.refreshWholesales();
                break;
            }
          }
        });
      } else {
        Axios.put(
          `${config.hostname}/v1/wholesale/` + idx,
          {},
          {
            withCredentials: true
          }
        ).then(async ({ data }) => {
          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                this.added.push(idx);
                await this.refreshWholesales();
                break;
            }
          }
        });
      }
    },
    async onAutoComplete() {
      if (this.search === "") return;
      if (this.search.length <= 2) return;
      const currentTime = new Date();
      if (currentTime - this.latestComplete <= 1000) return;
      this.latestComplete = currentTime;
      const {
        data
      } = await Axios.get(
        `${config.hostname}/v1/wholesale/add/pre?search=` + this.search,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.autoComplete = data.wholesales;
            break;
        }
      }
    },
    onDone() {
      this.visible = false;
      this.refreshWholesales();
    },
    onSearchChange(e) {
      if (e.key !== "Enter") return;
      this.onSearch();
    }
  },
  mounted() {
    this.added = _.map(this.$store.state.wholesale.wholesales, "idx");
  }
};
</script>